import { render, staticRenderFns } from "./SmartTrashManagerView.vue?vue&type=template&id=414ebe9b&"
import script from "./SmartTrashManagerView.vue?vue&type=script&lang=js&"
export * from "./SmartTrashManagerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports